import { render, staticRenderFns } from "./404Page.vue?vue&type=template&id=87822c2c&scoped=true&"
import script from "./404Page.vue?vue&type=script&lang=js&"
export * from "./404Page.vue?vue&type=script&lang=js&"
import style0 from "./404Page.vue?vue&type=style&index=0&id=87822c2c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87822c2c",
  null
  
)

export default component.exports